<template>
    <div v-if="modalContent.length === 0" class="a-loader--modal"></div>
    <div v-else>
        <div v-for="data in modalContent">
            <component :is="key" v-for="(value, key) in data" :data="value"></component>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Heading from 'components/modal/Heading.vue';
    import Paragraph from 'components/modal/Paragraph.vue';
    import TableData from 'components/modal/TableData.vue';
    import Formula from 'components/modal/Formula.vue';
    import HtmlString from 'components/modal/HtmlString.vue';

    export default {
        name: 'modal-content',
        computed: {
            ...mapGetters('modal', ['modalContent']),
        },
        components: {
            Heading,
            Paragraph,
            TableData,
            Formula,
            HtmlString,
        }
    }
</script>



// WEBPACK FOOTER //
// ModalContent.vue?3c5fb4f4